export const REFERRAL_COOKIE_NAME = "sup_ref";
export const REFERRAL_COOKIE_DURATION = 30; // days

export const handleReferralCode = () => {
  const params = new URLSearchParams(window.location.search);
  const refCode = params.get("ref");

  if (refCode) {
    const expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + REFERRAL_COOKIE_DURATION);
    document.cookie = `${REFERRAL_COOKIE_NAME}=${refCode};expires=${expiryDate.toUTCString()};path=/`;
  }
};
